<script lang="ts">
  import {cn} from 'Catalyst/cn';
  import {Icon} from 'Catalyst/components/Icon';
  import {
    badgeSlotsCloseIconDensity,
    badgeSlotsCloseIconGlyph,
    badgeSlotsCloseIconSize,
    badgeSlotsLeadingIconDensity,
    badgeSlotsLeadingIconGlyph,
    badgeSlotsLeadingIconSize,
  } from 'Catalyst/tokens/output/badge';
  import {Badge} from 'flowbite-svelte';
  import {noop} from 'lodash';
  import {type BadgeProps, badgeTvProps} from '.';

  // eslint-disable-next-line no-unused-vars
  type $$Props = BadgeProps;

  export let label: BadgeProps['label'] = 'Label';
  export let leadingIcon: BadgeProps['leadingIcon'] = false;
  export let semantic: BadgeProps['semantic'] =
    badgeTvProps.defaultVariants.semantic;
  export let size: BadgeProps['size'] = badgeTvProps.defaultVariants.size;
  export let onClose: BadgeProps['onClose'] = noop;
  export let leadingEmojiGlyph: BadgeProps['leadingEmojiGlyph'] = '';
  export let customLeadingIconGlyph: BadgeProps['customLeadingIconGlyph'] =
    null;

  $: badgeTvSlots = badgeTvProps({size, semantic});

  $: klass = $$restProps.class;
</script>

<Badge class={cn(badgeTvSlots.base(), klass)} data-testid="badge-component">
  {#if !!leadingEmojiGlyph}
    <span>{leadingEmojiGlyph}</span>
  {/if}
  {#if leadingIcon}
    <Icon
      density={badgeSlotsLeadingIconDensity}
      filled
      name={customLeadingIconGlyph || badgeSlotsLeadingIconGlyph}
      size={badgeSlotsLeadingIconSize}
    />
  {/if}
  <span class={badgeTvSlots.label()}>{label}</span>
  {#if onClose !== noop}
    <button class="leading-[0]" type="button" on:click={onClose}>
      <Icon
        density={badgeSlotsCloseIconDensity}
        filled
        name={badgeSlotsCloseIconGlyph}
        size={badgeSlotsCloseIconSize}
      />
    </button>
  {/if}
</Badge>
